import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const SubModelOption = (props) => {
  const MODELS = {
    cars: {
      value: "car",
      name: "cars",
    },
    motors: {
      value: "motor",
      name: "motors",
    },
    commercials: {
      value: "commercial",
      name: "commercials",
    },
  };
  if (props.showSubModel) {
    return (
      <>
        <h4>Select {props.modelTitle} type</h4>
        <Row className="my-5">
          {Object.values(MODELS).map((model) => {
            let subModel = null;
            if (props.model) {
              subModel = props.model.split("_")[0];
            }
            return (
              <Col key={model.value} xs={6} lg={4} xl={3} className="my-1">
                <Card
                  className={`border-0 shadwo-sm select-card ${
                    subModel !== model.value
                      ? `select-card__${model.name}`
                      : `select-card__${model.name}--selected text-white`
                  } cursor-pointer`}
                  onClick={() => props.setSubModel(model.value)}
                >
                  <Card.Body>
                    <p className="text-capitalize">{model.name}</p>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </>
    );
  } else return null;
};

export default SubModelOption;
